import BaseApiService from './base-api-service';

import { OilCoalModel } from '../models/oil-coal';

export default class OilCoalService extends BaseApiService {
  public async getOilCoal(): Promise<OilCoalModel> {
    const response = await this.getResource('/GetBrent_Coal_Eua');
    return response;
  }
}
